import wixWindowFrontend from "wix-window-frontend";
import wixApplication from "wix-application";
import { products } from 'wix-stores.v2'
import { fetch } from "wix-fetch";

async function getProduct(productId) {
    const productsApi = products.getProduct ?
        products :
        // @ts-expect-error
        products.products;
    
    return productsApi.getProduct(productId);
}

$w.onReady(function() {
    // $w('#note-container').collapse();
})

$widget.onPropsChanged(async (oldProps, newProps) => {
    const { productId, threshold } = newProps;
    const container = $w('#box1');
    container.collapse();
    $w('#note-container').collapse();

    const productIdChanged = productId && productId !== oldProps.productId;
    const thresholdChanged = threshold && threshold !== oldProps.threshold;
    const shouldComponentUpdate = productIdChanged || thresholdChanged;

    if (!shouldComponentUpdate) {
        return;
    }

    if (wixWindowFrontend.viewMode === 'Editor') {
        container.expand();
    }

    let product;

    try {
        product = (await getProduct(productId)).product;
    } catch (e) {
        console.error('getProduct', e);
        return;
    }

    const instance = await wixApplication.getDecodedAppInstance();

    const { instanceId } = instance;

    const chartsResponse = await fetch("https://size-chart.wowai.dev/api/charts/" + instanceId, { method: "get" });
    const charts = await chartsResponse.json();
    if (charts.length === 0 && wixWindowFrontend.viewMode === 'Editor') {
        $w('#note-container').expand();
    }

    $w('#button1').onClick(() => {
        wixWindowFrontend.openModal("https://size-chart.wowai.dev/charts/" + instanceId +"/" + productId + "/modal-view", {
            width: 900,
            height: 700,
        });
    });

    const chartResponse = await fetch("https://size-chart.wowai.dev/api/charts/" + instanceId + "/" + productId, { method: "get" });
    if (chartResponse.ok) {
        container.expand();
    }
});